<template>
  <div>
    <b-form-group
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.label"
      :style="properties.style"
    >
      <v-select></v-select>
    </b-form-group>
    <div v-if="showType == 'properties'"></div>
    <b-form-group
      v-if="
        (showType == 'form-submitter' && page == currentPage) ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :description="
        computedConditions.description
          ? computedPropertiesForm.description
          : properties.description
      "
      :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      "
      :style="properties.style"
      :hidden="computedHidden"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <v-select
        v-model="controlValue"
        :options="computedPropertiesForm.options"
        :multiple="properties.multiselect"
      ></v-select>
    </b-form-group>
    <b-form-group
      v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      "
      :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      "
    >
      {{ controlValueText }}
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
export default {
  name: "DropdownV1",
  props: ["showType", "properties", "form", "id", "results", "page", "componentsIdSuffix"],
  data() {
    return {
      computedProperties: ["description", "label", "hidden", "options"],
      computedConditions: {}
    };
  },
  mounted() {
    if(this.componentsIdSuffix) {
        this.initializeComponentValue({
          controlId: this.id,
          properties: this.properties
        });
      }
    this.computeConditions();
  },
  methods: {
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group">
        <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          ${this.controlValue ? this.controlValue : ""}
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors,
      currentPage: state => state.form.currentPage
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    controlValueText() {
      return this.controlValue && Array.isArray(this.controlValue)
        ? this.controlValue.join(", ")
        : "";
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>
